<script setup lang="ts">
// Test-environment banner (test-env runbook): visible ONLY off-production.
// NOTE: an identical copy of this file lives in bizinix-fe-mmll —
// there is no shared package between the repos, keep both in sync.
const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const isProdHost =
  hostname === 'bizinix.sk' || hostname === 'www.bizinix.sk' || hostname === 'admin.bizinix.sk';
const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '';
const showBanner = !isProdHost && !isLocalhost;
</script>

<template>
  <div
    v-if="showBanner"
    class="sticky top-0 z-[9999] flex items-center justify-center bg-red-600 px-4 py-2 text-center text-sm font-bold uppercase tracking-wide text-white"
    role="alert"
  >
    Nachádzate sa na testovacom prostredí — zmeny sa neprejavia na produkcii
  </div>
</template>
